import Head from 'next/head';
import { NextSeo } from 'next-seo';

//screen
import { Login } from '@/screens/Login';

const LoginPage = () => {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Login, login page, loadsmart login, opendock login, shipper guide login, navtrac login"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="Login Page | Loadsmart"
        description="Access the Login area for all the Loadsmart services."
        canonical="https://loadsmart.com/login/"
        openGraph={{
          url: 'https://loadsmart.com/login/',
        }}
      />

      <Login />
    </>
  );
};

export default LoginPage;
